'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
// import { Link } from 'react-router';

// import { ModalVoucherDetail } from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _reactBootstrap = require('react-bootstrap');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Marker = require('./Marker');

var _Marker2 = _interopRequireDefault(_Marker);

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _lib = require('helpers/lib');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _global = require('global');

var _global2 = _interopRequireDefault(_global);

var _ImageGallery = require('./ImageGallery');

var _ImageGallery2 = _interopRequireDefault(_ImageGallery);

var _lodash = require('lodash');

var _STAR = require('assets/img/STAR.gif');

var _STAR2 = _interopRequireDefault(_STAR);

var _components = require('components');

var _ = require('./');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Helper } from 'helpers/support';
var GoogleMapConfig = {
  key: 'AIzaSyDfMiEOFWpSUKrZVvIIaBE-vx8M9m_E5bk'
};
var DetailMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    shop: state.shops.shop,
    reviews: state.shops.reviews,
    media: state.shops.media,
    reviewLoad: state.shops.reviewLoad,
    postCount: state.reviews.postCount,
    categories: state.setup.categories,
    location: state.user.coords,
    loading: state.shops.loading_detail,
    loaded: state.shops.loaded_detail,
    groupServices: state.booking.groupServices
  };
}, (0, _extends3.default)({}, shopActions, {
  changeHeader: setupActions.changeHeader,
  setPathName: setupActions.setPathName,
  resetBooking: bookingActions.resetBooking,
  loadSlots: bookingActions.loadSlots,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  loadService: bookingActions.loadService,
  changeService: bookingActions.changeService,
  showDownloadAppPopup: setupActions.showDownloadAppPopup
})), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DetailMobile, _Component);

  function DetailMobile(props) {
    (0, _classCallCheck3.default)(this, DetailMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DetailMobile.__proto__ || (0, _getPrototypeOf2.default)(DetailMobile)).call(this, props));

    _this.state = {
      center: { lat: 10.8, lng: 106.63 },
      zoom: 14,
      showUpload: false,
      files: [],
      showModalNewReview: false,
      hour: {
        hour: '7:00 AM',
        available: true
      },
      currentMaxShowComments: 2,
      currentIndexImage: 0,
      showModalMap: false,
      showOptionHour: false,
      loadReview: false,
      bookDate: (0, _moment2.default)(),
      showFullComment: false,
      loaded: false,
      id: '',
      fixedTab: false,
      showAllMedia: false,
      showModalMedia: false,
      showModalAlertLogin: false,
      likeStatus: false,
      bookmarkStatus: false,
      firstLoad: false,
      move: 0,
      moveStart: 0
    };

    _this.onScroll = function (event) {
      var heightDetail = _this.detailDiv ? _this.detailDiv.clientHeight : 0;
      var heightWindow = _global2.default.innerHeight;
      if (event.type === 'touchstart') {
        _this.setState({ moveStart: event.changedTouches[0].screenY });
      } else if (event.type === 'touchend') {
        var move = _this.state.move + _this.state.moveStart - event.changedTouches[0].screenY;
        move = move > heightDetail - heightWindow ? heightDetail - heightWindow : move;
        move = move < 0 ? 0 : move;
        var fixedTab = move > 205;
        _this.setState({ move: move, fixedTab: fixedTab });
      }
    };

    _this.handleCloseModalAlertLogin = function () {
      _this.setState({ showModalAlertLogin: false });
    };

    _this.handleChangeHour = function (hour) {
      _this.setState({ hour: hour });
      _this.setState({ showOptionHour: false });
    };

    _this.handleShowHideOptionHour = function () {
      var currentStatus = _this.state.showOptionHour;
      _this.setState({ showOptionHour: !currentStatus });
    };

    _this.handleCloseModalMedia = function () {
      _this.setState({
        showModalMedia: false
      });
    };

    _this.handleOpenModalMedia = function (index) {
      _this.setState({
        currentIndexImage: index,
        showModalMedia: true
      });
    };

    _this.handleChangeBookDate = function (date) {
      _this.setState({ bookDate: date });
    };

    _this.setNewCurrentIndex = function (index) {
      _this.setState({
        currentIndexImage: index
      });
    };

    _this.review = function (event) {
      event.preventDefault();
      if (_this.props.user) {
        _this.props.history.push('/' + _this.props.shop.handle + '/viet-danh-gia');
      } else {
        _this.setState({
          showModalAlertLogin: true
        });
      }
    };

    _this.toReviewPage = function (event) {
      event.preventDefault();
      _this.props.history.push('/' + _this.props.shop.handle + '/danh-gia');
    };

    _this.redirectLogin = function () {
      _this.props.setPathName(_this.props.params.id);
      _this.props.history.push('/dang-nhap');
    };

    _this.likeShop = function (event) {
      event.preventDefault();
      if (!_this.props.user) {
        _this.setState({
          showModalAlertLogin: true
        });
      } else {
        _this.props.likeShop(_this.props.shop._id);
      }
    };

    _this.handleShowModalMap = function () {
      if (_this.props.shop && _this.props.shop.location) {
        _this.setState({
          showModalMap: true
        });
      }
    };

    _this.handleCloseModalMap = function () {
      _this.setState({
        showModalMap: false
      });
    };

    _this.bookmarkShop = function (event) {
      event.preventDefault();
      if (!_this.props.user) {
        _this.setState({
          showModalAlertLogin: true
        });
      } else {
        _this.props.bookmarkShop(_this.props.shop._id);
      }
    };

    _this.handleShowMoreButton = function () {
      _this.setState({
        currentMaxShowComments: _this.state.currentMaxShowComments + 2
      });
    };

    _this.renderDistance = function (userLocation, shopLocation) {
      var distance = Math.round((0, _lib.getDistanceFromLatLon)(userLocation.latitude, userLocation.longitude, shopLocation.lat, shopLocation.lng));
      if (distance > 1000) return Math.round(distance / 1000 * 10) / 10 + 'km';
      if (isNaN(distance)) return 'Không xác định';
      return distance + 'm';
    };

    _this.renderThumbnail = function (src, key, length, styles) {
      return _react2.default.createElement(
        'div',
        {
          className: styles.currentImage,
          style: { backgroundImage: 'url("' + (0, _lib.getUrlImage)(src.asset) + '")' }
        },
        _react2.default.createElement('div', { className: styles.fadeInfoImage }),
        _react2.default.createElement(
          'div',
          { className: styles.authorImage },
          _react2.default.createElement('img', {
            src: src && src.author && (0, _lib.getAvatar)(src.author) || (0, _lib.getAvatar)(),
            style: {
              float: 'left',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              display: 'inline-block',
              marginRight: '9px'
            }
          }),
          _react2.default.createElement(
            'div',
            { className: styles.authorImageName },
            src.author.profile.name
          ),
          _react2.default.createElement(
            'div',
            { className: styles.dateUpload },
            ' (',
            (0, _lib.renderTime)(src.date),
            ')'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.imageIndex },
            key + 1,
            '/',
            length
          )
        )
      );
    };

    _this.toBooking = _this.toBooking.bind(_this);
    _this.toMoreInfo = _this.toMoreInfo.bind(_this);
    _this.toMessenger = _this.toMessenger.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DetailMobile, [{
    key: 'componentDidMount',

    // componentWillMount() {
    // const { changeHeader } = this.props;
    // }
    value: function componentDidMount() {
      _global2.default.addEventListener('touchstart', this.onScroll, false);
      _global2.default.addEventListener('touchend', this.onScroll, false);
      this.props.getShopData(this.props.params.id);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _global2.default.scroll(0, 0);
      _global2.default.removeEventListener('touchstart', this.onScroll, false);
      _global2.default.removeEventListener('touchend', this.onScroll, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var loadService = nextProps.loadService,
          changeHeader = nextProps.changeHeader,
          shop = nextProps.shop;

      if (this.props.params.id !== nextProps.params.id) {
        this.props.getShopData(nextProps.params.id);
        document.getElementById('app-content').scrollTop = 0;
      }
      if (nextProps && shop && !(0, _lodash.isEqual)(this.props.shop, shop)) {
        loadService(shop._id);
        changeHeader('ShopDetail', {
          title: shop.name,
          logo: false
        });
      }
      if (this.props.shop && shop && (!(0, _lodash.isEqual)(this.props.shop.totalLike, shop.totalLike) || !(0, _lodash.isEqual)(this.props.shop.totalBookmark, shop.totalBookmark))) {
        this.props.getShopData(this.props.params.id);
      }
    }
  }, {
    key: 'toBooking',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(status, item) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.showDownloadAppPopup();
                // const { user } = this.props;
                // if (user) {
                //   const {
                //     shop,
                //     resetBooking,
                //     changeShopBeforeBooking,
                //     changeService,
                //   } = this.props;
                //   resetBooking();
                //   changeShopBeforeBooking(shop, user);
                //   if (status === 'service') {
                //     const service = { service: item._id, number: 1, name: item.name };
                //     changeService(service);
                //   }
                //   this.props.history.push(`/dat-lich`);
                //   ReactGA.event({
                //     category: 'Booking',
                //     action: 'Clicked To Step 1 (Shop Details)',
                //     label: `${shop.name}`,
                //   });
                // } else {
                //   const {
                //     shop,
                //     resetBooking,
                //     changeShopBeforeBooking,
                //     changeService,
                //   } = this.props;
                //   resetBooking();
                //   changeShopBeforeBooking(shop);
                //   if (status === 'service') {
                //     const service = { service: item._id, number: 1, name: item.name };
                //     changeService(service);
                //   }
                //   this.props.history.push(`/dat-lich`);
                //   ReactGA.event({
                //     category: 'Booking',
                //     action: 'Clicked Booking button (not logged in)',
                //     label: `${shop.name}`,
                //   });
                // }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toBooking(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return toBooking;
    }()
  }, {
    key: 'toMoreInfo',
    value: function toMoreInfo() {
      this.props.history.push('/thong-tin-shop/' + this.props.params.id);
    }
  }, {
    key: 'toMessenger',
    value: function toMessenger() {
      this.props.history.push('chat/' + this.props.shop.handle);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./DetailMobile.scss');
      var _state = this.state,
          currentMaxShowComments = _state.currentMaxShowComments,
          showModalMap = _state.showModalMap,
          showModalAlertLogin = _state.showModalAlertLogin,
          showModalMedia = _state.showModalMedia,
          currentIndexImage = _state.currentIndexImage,
          fixedTab = _state.fixedTab;
      var _props = this.props,
          reviewLoad = _props.reviewLoad,
          shop = _props.shop,
          loading = _props.loading,
          location = _props.location,
          loaded = _props.loaded,
          groupServices = _props.groupServices;
      var reviews = reviewLoad.reviews,
          media = reviewLoad.media,
          averagePoint = reviewLoad.averagePoint,
          good = reviewLoad.good,
          normal = reviewLoad.normal,
          bad = reviewLoad.bad,
          poor = reviewLoad.poor;

      var reviewsRender = reviews ? reviews : [];
      // reviewsRender = reviewsRender.filter( r => (r.status === 'available' || (user && user._id === r.user_id._id)));
      // const reviewRating = reviewsRender.filter( r => (r.status === 'available' || (user && user._id === r.user_id._id)));
      var colorCode = (0, _lib.getColorRatingCode)(averagePoint);
      var stylePoint = {
        backgroundColor: colorCode
      };
      var thumbnailStyle = {
        backgroundImage: 'url("' + (shop && (0, _lib.getUrlImage)(shop.image)) + '")'
      };
      var height = '200px';
      height = _global2.default.innerWidth / 3;
      var items = [];
      media.map(function (med, key) {
        items.push({
          thumbnail: '' + (0, _lib.getUrlImage)(med.asset),
          original: '' + (0, _lib.getUrlImage)(med.asset),
          asset: med.asset,
          author: med.author || 'Shop',
          date: med.date,
          key: key,
          length: media.length,
          styles: styles
          // renderItem: this.renderThumbnail
        });
      });
      var mainCat = [];
      var subCat = [];
      if (shop && shop.category && shop.category.length > 0) {
        shop.category.map(function (cat) {
          if (cat.length === 3) {
            subCat.push(cat);
          } else {
            mainCat.push(cat);
          }
        });
      }
      var phoneCall = '';
      var likeStatus = false;
      var bookmarkStatus = false;
      var chains = null;
      if (shop) {
        phoneCall = shop.phone;
        if (phoneCall.indexOf('-') !== -1) {
          phoneCall = phoneCall.split('-')[0].trim();
        }
        likeStatus = shop && shop.isLiked ? shop.isLiked : false;
        bookmarkStatus = shop && shop.isBookmarked ? shop.isBookmarked : false;
        shop.address = shop.addressDisplay ? shop.addressDisplay : shop.address;
        chains = shop.chains;
      }
      var meta = [];
      var imageSeo = shop ? shop.image : '';
      imageSeo = shop && shop.imageSeo ? shop.imageSeo : imageSeo;
      if (imageSeo) {
        meta.push({ property: 'og:image', content: imageSeo });
      }
      var title = shop && shop.name ? shop.name : '';
      title = shop && shop.title ? shop.title : title;
      if (title) {
        meta.push({ property: 'og:title', content: title });
      }
      var url = location ? _config2.default.siteUrl + location.pathname : '';
      if (url) {
        meta.push({ property: 'og:url', content: url });
      }
      var description = shop && shop.description ? shop.description : '';
      if (description) {
        meta.push({
          name: 'description',
          property: 'og:description',
          content: description
        });
      }
      if (loaded && !shop) {
        return _react2.default.createElement(_components.NotFoundMobile, null);
      }
      var offPromotion = false;
      return _react2.default.createElement(
        'div',
        {
          className: styles.detail,
          id: 'detail-page',
          ref: function ref(detailDiv) {
            return _this2.detailDiv = detailDiv;
          }
        },
        _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta }),
        loading && _react2.default.createElement(
          'div',
          { className: styles.loadingFade },
          _react2.default.createElement(
            'div',
            { className: styles.loading },
            _react2.default.createElement('img', { src: _STAR2.default })
          )
        ),
        shop && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.thumbnailContainer, style: thumbnailStyle },
            _react2.default.createElement('div', { className: styles.mysteriousCircle }),
            _react2.default.createElement(
              'div',
              { className: styles.point, style: stylePoint },
              averagePoint === 0 ? '--' : averagePoint
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.basicInfo },
            _react2.default.createElement(
              'div',
              { className: styles.category },
              this.props.categories && shop.category && (0, _lib.paserCategory)(this.props.categories, shop.category)
            ),
            _react2.default.createElement(
              'div',
              { className: styles.name },
              shop.name
            ),
            _react2.default.createElement(
              'div',
              { className: styles.likesCmt },
              _react2.default.createElement(
                'span',
                { className: styles.like },
                _react2.default.createElement('i', { className: 'fa fa-heart-o' }),
                ' ',
                shop.totalLike
              ),
              _react2.default.createElement('i', { className: 'fa fa-bookmark-o' }),
              ' ',
              shop.totalBookmark
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.actionBtnContainer + (fixedTab ? ' ' + styles.fixedTabbar : ''),
              ref: 'tabbar'
            },
            _react2.default.createElement(
              'div',
              { className: styles.actionBtn },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('i', {
                  className: 'fa fa-heart' + (likeStatus ? ' ' + styles.active : '-o'),
                  onClick: this.likeShop
                })
              ),
              _react2.default.createElement(
                'div',
                null,
                likeStatus ? 'Bỏ thích' : 'Thích'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionBtn, onClick: this.review },
              _react2.default.createElement('i', { className: 'fa fa-pencil' }),
              _react2.default.createElement(
                'div',
                null,
                '\u0110\xE1nh gi\xE1'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionBtn, onClick: this.bookmarkShop },
              _react2.default.createElement('i', {
                className: 'fa fa-bookmark' + (bookmarkStatus ? ' ' + styles.active : '-o')
              }),
              _react2.default.createElement(
                'div',
                null,
                bookmarkStatus ? 'Huỷ lưu' : 'Lưu'
              )
            ),
            shop && shop.isBooking ? _react2.default.createElement(
              'a',
              { onClick: this.toBooking },
              _react2.default.createElement(
                'div',
                { className: styles.actionBtn },
                _react2.default.createElement('i', { className: 'fa fa-phone' }),
                _react2.default.createElement(
                  'div',
                  null,
                  '\u0110\u1EB7t L\u1ECBch'
                )
              )
            ) : _react2.default.createElement(
              'a',
              { href: 'tel:' + phoneCall },
              _react2.default.createElement(
                'div',
                { className: styles.actionBtn },
                _react2.default.createElement('i', { className: 'fa fa-phone' }),
                _react2.default.createElement(
                  'div',
                  null,
                  'G\u1ECDi'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.infoMap + ' ' + styles.topic },
            _react2.default.createElement(
              'div',
              { className: styles.topicBody },
              _react2.default.createElement(
                'div',
                { className: styles.info },
                _react2.default.createElement(
                  'div',
                  { className: styles.title },
                  'Th\xF4ng Tin'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-map-marker' }),
                  shop.address
                ),
                location && shop.location && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-compass' }),
                  'C\xE1ch t\xF4i: ',
                  this.renderDistance(location, shop.location)
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
                  'M\u1EDF c\u1EEDa:',
                  ' ',
                  shop.openTime && shop.closeTime ? (0, _lib.number2Time)(shop.openTime) + ' - ' + (0, _lib.number2Time)(shop.closeTime) : shop.opening_time
                ),
                _react2.default.createElement(
                  'a',
                  { href: 'tel:' + phoneCall },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-phone' }),
                    shop.phone
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.moreInfoTitle,
                    onClick: this.toMoreInfo
                  },
                  'XEM TH\xCAM TH\xD4NG TIN'
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.map,
                  onClick: function onClick() {
                    return _this2.handleShowModalMap();
                  }
                },
                _react2.default.createElement('div', { className: styles.fade }),
                shop && shop.location && _react2.default.createElement(
                  _googleMapReact2.default,
                  {
                    center: shop.location,
                    resetBoundsOnResize: true,
                    zoom: this.state.zoom,
                    bootstrapURLKeys: GoogleMapConfig
                  },
                  _react2.default.createElement(_Marker2.default, { lat: shop.location.lat, lng: shop.location.lng })
                )
              )
            )
          ),
          !!(chains && chains.length) && _react2.default.createElement(
            'div',
            { className: styles.branchContainer + ' ' + styles.topic },
            _react2.default.createElement(
              'div',
              { className: styles.topicHeader },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                'Chi nh\xE1nh kh\xE1c'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.topicBody },
              chains.map(function (v) {
                return _react2.default.createElement(
                  _reactRouter.Link,
                  { to: v.handle, key: v.handle },
                  _react2.default.createElement(_.BranchShopCard, {
                    key: v.id,
                    thumbnail: v.image || '',
                    averagePoint: v.averagePoint,
                    address: v.addressDisplay || v.address || v.name
                  })
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.mediaContainer + ' ' + styles.topic },
            _react2.default.createElement(
              'div',
              { className: styles.mediaHeader + ' ' + styles.topicHeader },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                'H\xECnh \u1EA3nh'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.subTitle },
                media.length,
                ' \u1EA3nh \u2022 0 video'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.mediaList + ' ' + styles.topicBody },
              media && media.map(function (med, index) {
                if (index < 5 || index === 5 && media.length === 6) {
                  var thumbStyle = {
                    background: 'url(\'' + (0, _lib.getUrlImage)(med.asset) + '\') no-repeat center/cover',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    height: '' + height
                  };
                  return _react2.default.createElement(_reactBootstrap.Col, {
                    xs: 4,
                    sm: 4,
                    key: index,
                    className: styles.mediaAsset,
                    onClick: function onClick() {
                      return _this2.handleOpenModalMedia(index);
                    },
                    style: thumbStyle
                  });
                }
                if (index === 5 && media.length > 6) {
                  var _thumbStyle = {
                    background: 'url(\'' + (0, _lib.getUrlImage)(med.asset) + '\') no-repeat center/cover',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    height: '' + height
                  };
                  return _react2.default.createElement(
                    _reactBootstrap.Col,
                    {
                      xs: 4,
                      sm: 4,
                      key: index,
                      className: styles.mediaAsset,
                      onClick: function onClick() {
                        return _this2.handleOpenModalMedia(index);
                      },
                      style: _thumbStyle
                    },
                    _react2.default.createElement('div', { className: styles.fade }),
                    _react2.default.createElement(
                      'div',
                      {
                        className: styles.remainAssetCount,
                        style: { lineHeight: height + 'px' }
                      },
                      '+',
                      media.length - 6
                    )
                  );
                }
              })
            )
          ),
          !offPromotion && _react2.default.createElement(_.PromotionDetailMobile, {
            history: this.props.history,
            shopId: shop._id,
            noCallHomeService: true
          }),
          !!(groupServices && groupServices.length > 0) && _react2.default.createElement(_.ServiceList, {
            shop: shop,
            services: groupServices,
            onChange: this.toBooking
          }),
          _react2.default.createElement(
            'div',
            { className: styles.commentContainer + ' ' + styles.topic },
            _react2.default.createElement(
              'div',
              { className: '' + styles.topicHeader },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                '\u0110\xE1nh gi\xE1'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.subTitle },
                reviewsRender && reviewsRender.length,
                ' \u0111\xE1nh gi\xE1'
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.summaryComment + ' ' + styles.topicBody,
                onClick: this.review
              },
              _react2.default.createElement(
                'div',
                { className: styles.pointBox },
                _react2.default.createElement(
                  'div',
                  { className: styles.point, style: stylePoint },
                  averagePoint === 0 ? '--' : averagePoint
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  '\u0110i\u1EC3m trung b\xECnh'
                )
              ),
              _react2.default.createElement('div', { className: styles.borderLeft }),
              _react2.default.createElement(
                'div',
                { className: styles.statisticContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.commentStatistic },
                  _react2.default.createElement(
                    'div',
                    { className: styles.iconReviewRating },
                    _react2.default.createElement('img', { src: '/icon/ic_good/ic_good.png' }),
                    _react2.default.createElement(
                      'div',
                      null,
                      good
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.iconReviewRating },
                    _react2.default.createElement('img', { src: '/icon/ic_normal/ic_normal.png' }),
                    _react2.default.createElement(
                      'div',
                      null,
                      normal
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.iconReviewRating },
                    _react2.default.createElement('img', { src: '/icon/ic_bad/ic_bad.png' }),
                    _react2.default.createElement(
                      'div',
                      null,
                      bad
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.iconReviewRating },
                    _react2.default.createElement('img', { src: '/icon/ic_poor/ic_poor.png' }),
                    _react2.default.createElement(
                      'div',
                      null,
                      poor
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.commentArea, onClick: this.review },
            _react2.default.createElement(
              'label',
              null,
              'Vi\u1EBFt \u0111\xE1nh gi\xE1...'
            )
          )
        ),
        shop && _react2.default.createElement(
          'div',
          { className: styles.listComments },
          reviewsRender && _react2.default.createElement(
            'div',
            null,
            reviewsRender.map(function (review, index) {
              if (index < currentMaxShowComments) {
                return _react2.default.createElement(_.ReviewMobile, { shop: shop, review: review, key: index });
              }
            }),
            currentMaxShowComments < reviewsRender.length && _react2.default.createElement(
              'div',
              { className: styles.showMore, onClick: this.toReviewPage },
              ' ',
              'Xem th\xEAm \u0111\xE1nh gi\xE1',
              ' '
            )
          )
        ),
        shop && _react2.default.createElement(_.GeneralViewMobile, {
          province: shop.province,
          category: subCat,
          mainCat: mainCat,
          id: this.props.params.id
        }),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalAlertLogin,
            hide: this.handleCloseModalAlertLogin,
            className: 'modal-alert-mobile'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalAlertLogin
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'B\u1EA1n c\u1EA7n ph\u1EA3i \u0111\u0103ng nh\u1EADp \u0111\u1EC3 c\xF3 th\u1EC3 tham gia \u0111\xE1nh gi\xE1'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: function onClick() {
                    return _this2.redirectLogin();
                  }
                },
                '\u0110\u0103ng nh\u1EADp'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnCancel,
                  onClick: this.handleCloseModalAlertLogin
                },
                'Hu\u1EF7'
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalMedia,
            hide: this.handleCloseModalMedia,
            className: 'modal-image-mobile'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalMedia
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalImage },
            _react2.default.createElement(
              'div',
              { className: styles.headerModalImage },
              shop && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  null,
                  shop.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.span },
                  media.length,
                  ' \u1EA3nh, 0 video'
                )
              )
            ),
            media && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_ImageGallery2.default, {
                showPlayButton: false,
                showBullets: false,
                showFullscreenButton: false,
                items: items,
                startIndex: currentIndexImage
              })
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalMap,
            hide: this.handleCloseModalMap,
            className: 'modal-map-mobile'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalMap
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalMap },
            _react2.default.createElement(
              'div',
              { className: styles.address },
              shop && shop.address
            ),
            shop && shop.location && _react2.default.createElement(
              _googleMapReact2.default,
              {
                center: shop.location,
                resetBoundsOnResize: true,
                zoom: this.state.zoom,
                bootstrapURLKeys: GoogleMapConfig
              },
              _react2.default.createElement(_Marker2.default, { lat: shop.location.lat, lng: shop.location.lng })
            )
          )
        )
      );
    }
  }]);
  return DetailMobile;
}(_react.Component), _class2.propTypes = {
  // @data
  totalRating: _react.PropTypes.number,
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  categories: _react.PropTypes.array,
  media: _react.PropTypes.array,
  groupServices: _react.PropTypes.array,
  reviews: _react.PropTypes.array,
  reviewLoad: _react.PropTypes.object,
  user: _react.PropTypes.object,
  params: _react.PropTypes.object,
  location: _react.PropTypes.object,
  history: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  // @action
  getShopData: _react.PropTypes.func,
  likeShop: _react.PropTypes.func,
  changeHeader: _react.PropTypes.func,
  bookmarkShop: _react.PropTypes.func,
  setPathName: _react.PropTypes.func.isRequired,
  bookingAction: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  loadSlots: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  loadService: _react.PropTypes.func,
  changeService: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = DetailMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/DetailMobile.js
// module id = 1588
// module chunks = 0